import { defineVariant } from '../v4/theme';

/* v5 "Gewächshaus": warm botanical palette, serif headings, soft shapes. */
export const V5_VARIANT = defineVariant({
  id: 'v5',
  basePath: '/v5',
  brand: 'EcoScope',
  tag: 'v5 · Gewächshaus',
  defaultMode: 'light',
  font: '"DM Sans","Inter","Helvetica Neue",sans-serif',
  headingFont: '"Fraunces","Georgia",serif',
  fontsHref: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Fraunces:opsz,wght@9..144,500;9..144,700;9..144,800&display=swap',
  radius: 20,
  tokens: {
    light: {
      bg:            '#f4f1ea',
      text:          '#1f2a1f',
      'muted-rgb':   '74,85,72',
      'fg-rgb':      '31,42,31',
      'surface-rgb': '255,253,248',
      'surface2-rgb':'250,247,240',
      'shadow-rgb':  '70,58,35',
      'shadow-k':    '0.25',
      cyan:          '#3f7d4e',
      'cyan-light':  '#5a9a68',
      'cyan-deep':   '#24502f',
      green:         '#5f8f2a',
      red:           '#b8492f',
      'red-soft':    '#b8492f',
      orange:        '#c27c12',
      purple:        '#8a5a83',
      gold:          '#a8820f',
      blue:          '#4a6f8a',
      teal:          '#2f7f72',
      neutral:       '#a8a29e',
      whatsapp:      '#128c4a',
      'glow-k':      '0.7',
    },
    dark: {
      bg:            '#0e1410',
      text:          '#e8efe4',
      'muted-rgb':   '175,190,170',
      'fg-rgb':      '232,239,228',
      'surface-rgb': '21,30,24',
      'surface2-rgb':'17,25,20',
      'shadow-rgb':  '0,0,0',
      'shadow-k':    '0.8',
      cyan:          '#5fae74',
      'cyan-light':  '#8fd19f',
      'cyan-deep':   '#2f6b3d',
      green:         '#9ccc65',
      red:           '#e07a5f',
      'red-soft':    '#e8907a',
      orange:        '#e9b04f',
      purple:        '#c39bd3',
      gold:          '#e6c84f',
      blue:          '#81a4cd',
      teal:          '#5fb3a3',
      neutral:       '#6b7368',
      whatsapp:      '#25d366',
      'glow-k':      '0.8',
    },
  },
});
